import React, { useState, Component, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Countdown from "react-countdown";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ProductCard from "../../Components/Product-Card/ProductCard";
import { Divider } from "@material-ui/core";
import api from "../../Axios/api";
import "./style.css";
import { useUserContext } from "../../context/UserContext";
import Rating from "@material-ui/lab/Rating";
//importing files
import noImage from "../../assets/images/Product Images/noImage.png";
import loadingImg from "../../assets/images/loadingImg.gif";

// MUI Components
import {
  Grid,
  Box,
  List,
  Button,
  Typography,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import AvTimerIcon from "@material-ui/icons/AvTimer";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";
import { Loop } from "@material-ui/icons";

export default function HomePage() {
  const classes = useStyles();
  const ref = useRef(null);
  const refReviewedProducts = useRef(null);
  let token = "";
  let userId = "";
  const { store } = useUserContext();
  const [data, setData] = useState([]);
  if (store.data !== null) {
    token = store.data.token;
    if (store.data.data) userId = store.data.data._id;
  }
  var subCategoryCountProducts = parseInt(0);
  const carouselImages = [
    {
      id: 1,
      img: "gs://digi-mart-4e2bf.appspot.com/carousel1.PNG",
      link: "/",
    },
    {
      id: 2,
      img: "../../assets/images/carousel/carousel2.PNG",
      link: "/",
    },
    {
      id: 3,
      img: "../../assets/images/carousel/corousel3.PNG",
      link: "/",
    },
  ];
  const [isLoading, setIsLoading] = useState(true);
  const [countOfMainCategoryBoxes, setCountOfMainCategoryBoxes] = useState(5)

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };
  const scrollReviewedProducts = (scrollOffset) => {
    refReviewedProducts.current.scrollLeft += scrollOffset;
  };

  const getLinkOfProductsByCategory = (category) => {
    return `/products?mainCategoryName=${encodeURIComponent(category)}`;
  };
  const getLinkOfProductsBySubCategory = (subCategory, category) => {
    return `/products?subCategoryName=${encodeURIComponent(subCategory)}&mainCategoryOfSubCategory=${encodeURIComponent(category)}`;
  };
  //List of sub categories
  function generateListOfSubCategories(item) {
    return (
      <div>
        <ListItem>
          <Link
            className={classes.LinkOfCategories}
            to={getLinkOfProductsByCategory(item.mainCategoryName)}
          >
            <ListItemText secondary="Best Sellers" />
          </Link>
        </ListItem>
        <ListItem>
          <Link
            className={classes.LinkOfCategories}
            to={getLinkOfProductsByCategory(item.mainCategoryName)}
          >
            <ListItemText secondary="New Arrivals" />
          </Link>
        </ListItem>
        {item.subCategories.map((subCategory) =>
          React.cloneElement(
            <ListItem>
              <Link
                className={classes.LinkOfCategories}
                to={getLinkOfProductsBySubCategory(
                  subCategory.name,
                  item.mainCategoryName
                )}
              >
                <ListItemText secondary={subCategory.name} />
              </Link>
            </ListItem>,
            {
              key: subCategory._id,
            }
          )
        )}
      </div>
    );
  }

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0)
    api
      .get(`/`, {}, { Headers: {} })
      .then((res) => {
        // console.log("data", res.data.data);
        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );
  }, []);

  const loadMoreCategoriesBoxes = () =>{
    setCountOfMainCategoryBoxes(countOfMainCategoryBoxes+4)
  }

  function categoriesAndSubCategoriesBox() {
    return data.ProductCategoriesInfo ? (
      data.ProductCategoriesInfo.slice(0, countOfMainCategoryBoxes).map((item, index) =>
        React.cloneElement(
          <Grid container className={classes.categoriesMainBox}>
            {/* SUB CATEGORIES NAMES BOX */}
            <Grid component="a" item xs={12} md={6} lg={3}>
              <Box borderLeft={5} borderColor="primary.main">
                <Typography
                  className={classes.dealsOfDayText}
                  variant="h2"
                  style={{ marginLeft: 13, paddingLeft: 20, textAlign: "left" }}
                >
                  {item.mainCategoryName}
                </Typography>
              </Box>
              <div>
                <List style={{ paddingLeft: 20 }}>
                  {generateListOfSubCategories(item)}
                  <ListItem style={{ paddingBottom: 0 }}>
                    <Link
                      className={classes.LinkOfCategories}
                      to={getLinkOfProductsByCategory(item.mainCategoryName)}
                    >
                      <ListItemText
                        style={{ fontStyle: "italic", marginTop: 30 }}
                        secondary="View all >>"
                      />
                    </Link>
                  </ListItem>
                </List>
              </div>
            </Grid>

            {/* PORTRAIT PICTURE BOX */}
            <Grid item xs={12} sm={11} md={12} lg={8} xl={4}>
              <Grid
                className={classes.categoryMainImgGrid}
                style={{ position: "relative" }}
              >
                <Link to={getLinkOfProductsByCategory(item.mainCategoryName)}>
                  <img
                    src={item.mainCategoryImage ? item.mainCategoryImage:"#"}
                    className={classes.categoryMainImg1}
                    style={{backgroundColor: !item.mainCategoryImage ? '#ffcccb': 'none'}}
                  ></img>
                </Link>
                <Typography
                  variant="h5"
                  className={classes.imgCategoryNameText}
                >
                  {item.mainCategoryName}
                </Typography>
                <Typography
                  noWrap
                  variant="h2"
                  style={{ fontWeight: "bold" }}
                  className={classes.imgMainText}
                >
                  Best Selling
                </Typography>
                <Link
                  style={{ textDecoration: "none" }}
                  to={getLinkOfProductsByCategory(item.mainCategoryName)}
                >
                  <Button
                    style={{
                      top: 150,
                      position: "absolute",
                      color: "white",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                    className={classes.btnCategoryImageBuyNow}
                  >
                    Buy Now
                  </Button>
                </Link>
              </Grid>
            </Grid>

            {/* SUB CATEGORIES PICTURES BOXES */}
            <Grid
              className={classes.subCategoryImgMainBox}
              justify="center"
              xs={12}
              sm={12}
              lg={12}
              xl={5}
              //xl={5}
            >
              {item.subCategories.slice(0, 4).map((subCategory) =>
                React.cloneElement(
                  <Grid
                    className={classes.subCategoryImgGrid}
                    xs={12}
                    md={12}
                    lg={6}
                  >
                    <Link
                      to={getLinkOfProductsBySubCategory(
                        subCategory.name,
                        item.mainCategoryName
                      )}
                      style={{ textDecoration: "none" }}
                    >
                      <Button className={classes.subCategoryImgButton} style={{backgroundColor:'transparent'}}>
                        <span
                          className={classes.spanBtn}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Typography
                            variant="p"
                            style={{
                              fontWeight: "bold",
                              letterSpacing: 1,
                              textOverflow: "ellipsis",
                            }}
                          >
                            {subCategory.name}
                          </Typography>
                          <Typography
                            variant="p"
                            style={{
                              color: "grey",
                              letterSpacing: 1,
                              textTransform: "none",
                            }}
                          >
                            {/* {subCategoryCountProducts = 0} */}
                            {(subCategoryCountProducts = undefined)}
                            {data.SubCategoriesProductCount.forEach(
                              (myItem) => {
                                if (
                                  myItem.subcategory === subCategory.name &&
                                  myItem.category === item.mainCategoryName
                                ) {
                                  subCategoryCountProducts = myItem.count;
                                }
                              }
                            )}
                            {subCategoryCountProducts
                              ? subCategoryCountProducts + " Product(s)"
                              : 0}
                          </Typography>
                          <img
                            className={classes.ImgSubCategory}
                            src={subCategory.image}
                            style={{visibility: subCategory.image ? 'visible':'hidden'}}
                          ></img>
                        </span>
                      </Button>
                    </Link>
                  </Grid>,
                  {
                    key: subCategory._id,
                  }
                )
              )}
            </Grid>
          </Grid>,

          {
            key: item._id,
          }
        )
      )
    ) : (
      <div>
        {/* <img className={classes.loadingImgDiv} src={loadingImg}></img> */}
      </div>
    );
  }

  return (
    //CAROUSEL
    <div>
      <Carousel
        className={classes.carouselBox}
        autoPlay={true}
        showThumbs={false}
        showStatus={false}
      >
        <div>
          <Link href="/">
            <img
              src="https://res.cloudinary.com/djyrghzsz/image/upload/f_auto,q_auto/fk9syudqrn2qjlxxidzq"
              className={classes.carouselImg}
            />
          </Link>
          {/* <Button className={classes.carouselBtn}>
              <Typography variant="h6">SHOP NOW</Typography>
          </Button> */}
        </div>
        <div>
          <Link href="/">
            <img
              className={classes.carouselImg}
              src="https://res.cloudinary.com/djyrghzsz/image/upload/f_auto,q_auto/xauxvnmhibbtywtngaen"
            />
          </Link>
        </div>
        <div>
          <Link href="/">
            <img
              className={classes.carouselImg}
              src="https://res.cloudinary.com/djyrghzsz/image/upload/f_auto,q_auto/pdc56hbidri73bjnstmy"
            />
          </Link>
        </div>
      </Carousel>

      {/* //SERVICES */}
      <Grid container direction="row" className={classes.servicesBox}>
        <div className={classes.service}>
          <AirportShuttleOutlinedIcon
            className={classes.serviceIcon}
            style={{ fontSize: "65px" }}
          />
          <div className={classes.servicesTextBox}>
            <Typography
              className={classes.serviceText}
              style={{ fontWeight: "bold" }}
            >
              Fast Delivery
            </Typography>
            <Typography
              className={classes.serviceTextLight}
              style={{ fontSize: 13 }}
            >
              Fast Delivery on all orders
            </Typography>
          </div>
        </div>

        <div className={classes.service}>
          <AccountBalanceWalletIcon
            className={classes.serviceIcon}
            style={{ fontSize: "65px" }}
          />
          <div className={classes.servicesTextBox}>
            <Typography
              className={classes.serviceText}
              style={{ fontWeight: "bold" }}
            >
              Money Return
            </Typography>
            <Typography
              className={classes.serviceTextLight}
              style={{ fontSize: 13 }}
            >
              Return guarantee in 7 days
            </Typography>
          </div>
        </div>

        <div className={classes.service}>
          <LoyaltyIcon
            className={classes.serviceIcon}
            style={{ fontSize: "65px" }}
          />
          <div className={classes.servicesTextBox}>
            <Typography
              className={classes.serviceText}
              style={{ fontWeight: "bold" }}
            >
              Exciting Offers
            </Typography>
            <Typography
              className={classes.serviceTextLight}
              style={{ fontSize: 13 }}
            >
              Exciting deals for new users
            </Typography>
          </div>
        </div>

        <div className={classes.service}>
          <QuestionAnswerIcon
            className={classes.serviceIcon}
            style={{ fontSize: "65px" }}
          />
          <div className={classes.servicesTextBox}>
            <Typography
              className={classes.serviceText}
              style={{ fontWeight: "bold" }}
            >
              Support 24/7
            </Typography>
            <Typography
              className={classes.serviceTextLight}
              style={{ fontSize: 13 }}
            >
              Get Support 24 hours a day
            </Typography>
          </div>
        </div>
      </Grid>

      {/* Row Images Section */}
      <div className={classes.mainConatinerAfterServices}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={6}>
            <Link href="/">
              <img
                xs={12}
                md={12}
                lg={6}
                className={classes.rowImg}
                src="https://res.cloudinary.com/djyrghzsz/image/upload/f_auto,q_auto/upzc7hju0r6aahdlgyh3"
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <Link href="/">
              <img
                xs={12}
                md={12}
                lg={6}
                className={classes.rowImg}
                src="https://res.cloudinary.com/djyrghzsz/image/upload/f_auto,q_auto/esqzeefj0avgirlp0zob"
              />
            </Link>
          </Grid>
        </Grid>

        {/* Deals Products Section */}

        <Grid className={classes.dealsBox}>
          <Box className={classes.DealsHeaderTextBox}>
            <Box
              className={classes.DealsHeaderTextdiv}
              borderLeft={5}
              borderColor="primary.main"
            >
              <Typography
                className={classes.dealsOfDayText}
                variant="h2"
                style={{ marginLeft: 13 }}
              >
                Deals Of The Day
              </Typography>
            </Box>
            <Typography
              className={classes.timerText}
              variant="h2"
              style={{ marginLeft: 29 }}
            >
              <AvTimerIcon
                style={{ marginRight: 8, position: "relative", top: "2px" }}
              />
              <Countdown date={Date.now() + 100000000} />
            </Typography>

            <div className={classes.navDealProductsBtnBox}>
              <Button
                onClick={() => scroll(-255)}
                padding={0}
                variant="contained"
                marginRight={10}
                style={{
                  padding: "0",
                  minWidth: "fit-content",
                }}
              >
                <ChevronLeftRoundedIcon />
              </Button>

              <Button
                onClick={() => scroll(255)}
                padding={0}
                margin={0}
                variant="contained"
                style={{
                  padding: "0",
                  minWidth: "fit-content",
                  marginLeft: 14,
                }}
              >
                <ChevronRightOutlinedIcon />
              </Button>
            </div>
          </Box>
          <Divider style={{ marginTop: 12, marginBottom: 12 }} />

          {/* DEAL PRODUCTS CARDS */}
          <Grid
            ref={ref}
            className={classes.DealProductsCardsScrollBox}
            style={{ justifyContent: isLoading ? "center" : "flex-start" }}
          >
            {data.ProductsOnSale ? (
              data.ProductsOnSale.map((item) =>
                React.cloneElement(
                  <ProductCard
                    image={item.images ? item.images : noImage}
                    title={item.name}
                    cutPrice={item.discountPrice ? item.salePrice : null}
                    price={
                      item.discountPrice ? item.discountPrice : item.salePrice
                    }
                    category={item.category}
                    isNew={item.state === "new" ? true : false}
                    rating={item.avgRating}
                    discountPercentage={
                      item.discountPercentage
                        ? item.discountPercentage
                        : ""
                    }
                    storeName={item.storeName}
                    totalRatingStars={item.totalRatingStars}
                    brand={item.vendorCompanyName}
                    shippingCost={item.shippingCost}
                    stockAvailable = {item.stockAvailable}
                    _id={item._id}
                  />,
                  {
                    key: item._id,
                  }
                )
              )
            ) : (
              <div>
                <img className={classes.loadingImgDiv} src={loadingImg}></img>
              </div>
            )}
          </Grid>
        </Grid>

        {/* Deals Products Section */}

        <Grid className={classes.dealsBox}>
          <Box className={classes.DealsHeaderTextBox}>
            <Box
              className={classes.DealsHeaderTextdiv}
              borderLeft={5}
              borderColor="primary.main"
            >
              <Typography
                className={classes.dealsOfDayText}
                variant="h2"
                style={{ marginLeft: 13 }}
              >
                Top Rated Products
              </Typography>
            </Box>
            <Typography
              className={classes.timerText}
              variant="h2"
              style={{ marginLeft: 29 }}
            >
              <Rating
                name="half-rating-read"
                defaultValue={5}
                style={{ fontSize: 22 }}
                precision={0.5}
                readOnly
              />
            </Typography>

            <div className={classes.navDealProductsBtnBox}>
              <Button
                onClick={() => scrollReviewedProducts(-255)}
                padding={0}
                variant="contained"
                marginRight={10}
                style={{
                  padding: "0",
                  minWidth: "fit-content",
                }}
              >
                <ChevronLeftRoundedIcon />
              </Button>

              <Button
                onClick={() => scrollReviewedProducts(255)}
                padding={0}
                margin={0}
                variant="contained"
                style={{
                  padding: "0",
                  minWidth: "fit-content",
                  marginLeft: 14,
                }}
              >
                <ChevronRightOutlinedIcon />
              </Button>
            </div>
          </Box>
          <Divider style={{ marginTop: 12, marginBottom: 12 }} />

          {/* DEAL PRODUCTS CARDS */}
          <Grid
            ref={refReviewedProducts}
            className={classes.DealProductsCardsScrollBox}
            style={{ justifyContent: isLoading ? "center" : "flex-start" }}
          >
            {data.TopReviewedProducts ? (
              data.TopReviewedProducts.map((item) =>
                item
                  ? React.cloneElement(
                      <ProductCard
                        image={item.images ? item.images : noImage}
                        title={item ? item.name : ""}
                        cutPrice={item.discountPrice ? item.salePrice : null}
                        price={
                          item
                            ? item.discountPrice
                              ? item.discountPrice
                              : item.salePrice
                            : ""
                        }
                        category={item.category}
                        isNew={item.state === "new" ? true : false}
                        rating={item.avgRating}
                        discountPercentage={
                          item
                            ? item.discountPercentage
                              ? item.discountPercentage
                              : ""
                            : ""
                        }
                        storeName={item.storeName}
                        totalRatingStars={item.totalRatingStars}
                        brand={item.vendorCompanyName}
                        shippingCost={item.shippingCost}
                        stockAvailable= {item.stockAvailable}
                        _id={item ? item._id : ""}
                      />,
                      {
                        key: item ? item._id : "",
                      }
                    )
                  : null
              )
            ) : (
              <div>
                <img className={classes.loadingImgDiv} src={loadingImg}></img>
              </div>
            )}
          </Grid>
        </Grid>

        {/* CATEGORIES MAIN BOX */}
        {categoriesAndSubCategoriesBox()}
        <div style={{width:'100%', display:'flex',alignItems:'center',justifyContent:'center', margin:20}}>
        <Button color="primary" variant="outlined" onClick={loadMoreCategoriesBoxes}>
          Load More
          <Loop style={{marginLeft:6}}/>
        </Button>
        </div>
      </div>
    </div>
  );
}
